import { render, staticRenderFns } from "./EventTitle.vue?vue&type=template&id=5b2c18dc&scoped=true&"
import script from "./EventTitle.vue?vue&type=script&lang=js&"
export * from "./EventTitle.vue?vue&type=script&lang=js&"
import style0 from "./EventTitle.vue?vue&type=style&index=0&id=5b2c18dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2c18dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
